import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Icon,
  Avatar,
  Box,
} from '@chakra-ui/react';
import { AlertTriangle } from 'lucide-react';
import { User } from '../../types';

interface TangentModalProps {
  isOpen: boolean;
  onClose: () => void;
  triggeredByUser?: User | null;
}

export function TangentModal({ isOpen, onClose, triggeredByUser }: TangentModalProps) {
  const handleGotIt = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody py={8}>
          <VStack spacing={6} textAlign="center">
            {triggeredByUser ? (
              <Box position="relative">
                <Avatar
                  size="2xl"
                  src={triggeredByUser.photoURL || triggeredByUser.photo}
                  name={triggeredByUser.name}
                  border="4px solid"
                  borderColor="red.600"
                />
              </Box>
            ) : (
              <Icon
                as={AlertTriangle}
                w={16}
                h={16}
                color="red.600"
              />
            )}
            
            <VStack spacing={1}>
              <Text
                fontSize="4xl"
                fontWeight="bold"
                color="red.600"
                letterSpacing="wide"
                lineHeight="1"
              >
                TANGENT
              </Text>
              {triggeredByUser && (
                <Text fontSize="md" fontWeight="medium" color="gray.600">
                  Called by {triggeredByUser.firstName || triggeredByUser.name}
                </Text>
              )}
            </VStack>

            <Text fontSize="lg" color="gray.600">
              Let's get back on track
            </Text>
            <Button
              colorScheme="red"
              size="lg"
              onClick={handleGotIt}
              width="full"
            >
              Got It
            </Button>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
